import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AspSettingsComponent } from './asp-settings.component'
import { RouterModule, Routes } from '@angular/router';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FormsModule } from '@angular/forms';
import { MatSelectModule } from '@angular/material/select';

const routes: Routes = [
  {
      path: 'settings',
      component: AspSettingsComponent,
  },
];

@NgModule({
  declarations: [AspSettingsComponent],
  imports: [
    RouterModule.forChild(routes),
    CommonModule,
    FormsModule,
    BrowserAnimationsModule, 
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule

  ] 
})
export class AspSettingsModule { }
